import React from "react";
import styles from "./PortalDrawer.module.css";
import { PortalDrawerData } from "../../../Data/PortalDrawerData";
import Tooltip from "../../../Components/Utils/Tooltip/Tooltip";

type PortalDrawerProps = {
  selectedItem: string;
  onItemSelect: (itemId: string) => void;
};

const PortalDrawer = ({ selectedItem, onItemSelect }: PortalDrawerProps) => {
  return (
    <div className={styles.drawer}>
      <nav className={styles.drawerNav}>
        {PortalDrawerData.map((item) =>
          item.disabledReason ? (
            <Tooltip key={item.id} text={item.disabledReason} align="bottom">
              <button
                type="button"
                className={`${styles.drawerItem} ${styles.drawerItemDisabled}`}
                disabled
              >
                {item.label}
              </button>
            </Tooltip>
          ) : (
            <button
              key={item.id}
              type="button"
              className={`${styles.drawerItem} ${
                selectedItem === item.id ? styles.drawerItemActive : ""
              }`}
              onClick={() => onItemSelect(item.id)}
            >
              {item.label}
            </button>
          )
        )}
      </nav>
    </div>
  );
};

export default PortalDrawer;
